var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFarms(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2377 13.6442L17.407 9.55157C17.392 9.51726 17.3665 9.48902 17.3343 9.47124L12.0788 6.52138C12.0539 6.5079 12.0263 6.50077 11.9982 6.50061C11.9698 6.50063 11.9419 6.50776 11.9168 6.52138L6.66124 9.47124C6.62927 9.48929 6.60378 9.51745 6.58854 9.55157L4.76137 13.6442C4.75098 13.6671 4.7456 13.692 4.74561 13.7173V20.5513C4.74561 20.5975 4.76341 20.6418 4.79512 20.6744C4.82682 20.7071 4.86982 20.7255 4.91466 20.7255H19.0844C19.1292 20.7255 19.1722 20.7071 19.2039 20.6744C19.2356 20.6418 19.2535 20.5975 19.2535 20.5513V13.7191C19.2537 13.6932 19.2483 13.6676 19.2377 13.6442Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.73292 8.34022L11.9992 4.81989L18.2664 8.34022L20.5438 13.4258L21.8201 12.8192L19.4481 7.5161C19.3849 7.37436 19.2789 7.2575 19.1459 7.18303L12.3382 3.36121C12.2352 3.30322 12.1197 3.27283 12.0023 3.27283C11.8849 3.27283 11.7694 3.30322 11.6664 3.36121L4.85875 7.18303C4.72575 7.2575 4.61974 7.37436 4.55656 7.5161L2.18457 12.8192L3.46079 13.4258L5.73292 8.34022Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFarms);
export default __webpack_public_path__ + "static/media/farms.684fee46cbd3a36bb5ecfd0e51258493.svg";
export { ForwardRef as ReactComponent };